<script setup lang="ts">
// import NavBar from './components/NavBar.vue'
// import CustomCard from './components/CustomCard.vue'
// import AislesCard from './components/AislesCard.vue'
// import NavBar from './components/NavBar.vue'
// import { ref, onMounted } from 'vue'
import { RouterView, useRouter } from 'vue-router';
import { createSegment, startSegment, getActiveSegment } from './api/index.ts';
// import { visitCreate } from './api/cService.ts';
import { useMainStore } from '@/stores/main.ts'
const mainStore = useMainStore()

// function generateRandomString(length: number) {
//   const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
//   let result = '';
//   const charactersLength = characters.length;
//   for (let i = 0; i < length; i++) {
//     result += characters.charAt(Math.floor(Math.random() * charactersLength));
//   }
//   return result;
// }
// console.log(generateRandomString(10)); // 示例输出: "A1b2C3d4E5"
if(mainStore.sessionid) {
  getActiveSegment({
  subsystem_id: mainStore.subsystemId,
  sessionid: mainStore.sessionid,
}).then((res) => {
  console.log(res)
  // return
  if (res.code === 0) {
    // @ts-check
    mainStore.setSegmentInfo(res.data)
    mainStore.setMonitoringStatus(1)
    // show.value = true;
  } else {
  }
})
}

// password
const router = useRouter()
// localStorage.setItem('token', '')
const isAuth = () => {
  const token = localStorage.getItem('token')
  if (!token) {
    // router.push('/loginView')
  } else {
    // router.push('/canvasView')
  }
}
isAuth()
// router.push('/selectRole')
// CSS中定义变量
// :root {
// --bg-color: #ffffff;
// }

// p {
// background-color: var(--bg-color);
// }

// // JavaScript中修改变量
// const button = document.querySelector('button');
// button.addEventListener('click', () => {
// document.documentElement.style.setProperty('--bg-color', 'red');
// });
</script>

<template>
  <!-- 头部 -->
  <RouterView />

</template>

<style>
/* @tailwind base;
@tailwind components;
@tailwind utilities; */
/* @import "tailwindcss"; */

@import './assets/main.css';
</style>
<style scoped lang="scss">
.container {
  background-color: #e4e7e9;
  display: flex;
  flex-direction: column;
}

.main {
  width: 100%;
  margin-top: 20px;
  display: flex;

  &-left {
    width: calc(100% - 380px);
    height: 100%;
    // float: left;
    margin-right: 20px;

  }

  &-right {
    width: 340px;
    height: 100%;
    float: left;
    box-sizing: border-box;

    &-card {
      margin-top: 20px;
    }
  }
}
</style>
